import SoundFx from '../../../components/SoundFx';

export default function InteractionFeature() {
  const target = document.getElementById('InteractionFeature');

  target.addEventListener('mouseenter', () => {
    SoundFx.Single.play('interactionHover');
  });

  target.addEventListener('mouseleave', () => {
    SoundFx.Single.play('interactionHover', true);
  });

  target.addEventListener('mousedown', () => {
    SoundFx.Single.play('interactionActive');
  });

  target.addEventListener('mouseup', () => {
    SoundFx.Single.play('interactionActive', true);
  });

  return target;
}
